import {Group} from 'src/design/atoms/Group';
import {Progress} from 'src/design/atoms/Progress';
import {Text} from 'src/design/atoms/Text';
import type {FC} from 'react';
import {HelpTooltip} from 'src/design/atoms/HelpTooltip';
import {useGetAssistantUsageQuery} from 'src/redux/queries/assistant';

const USER_TOOLTIP =
  'How much of your daily Scout allowance you have used. It resets daily. When it is full, Scout pauses until it resets.';
const INSTANCE_TOOLTIP =
  "Your organization's shared daily Scout allowance is the limit right now. It resets daily. When it is full, Scout pauses until it resets.";

export const AssistantUsageMeter: FC = () => {
  const {data, isLoading, isError} = useGetAssistantUsageQuery();
  if (isLoading) return null;
  if (isError)
    return (
      <Text size="xs" c="dimmed">
        Usage unavailable
      </Text>
    );
  if (!data) return null;

  const {userUsedPercent, instanceUsedPercent} = data;
  const raw = Math.max(userUsedPercent, instanceUsedPercent);
  const clamped = Math.min(100, Math.max(0, raw));
  const instanceDriven = instanceUsedPercent > userUsedPercent;

  const color = raw >= 100 ? 'red.8' : raw >= 80 ? 'yellow.8' : undefined;

  return (
    <Group gap="xs" wrap="nowrap" maw={420} style={{flex: 1}}>
      <Progress
        value={clamped}
        color={color}
        size="sm"
        style={{flex: 1}}
        aria-label="Daily Scout usage"
      />
      <Text size="xs" c="dimmed">
        {Math.round(clamped)}%
      </Text>
      <HelpTooltip text={instanceDriven ? INSTANCE_TOOLTIP : USER_TOOLTIP} />
    </Group>
  );
};
